import { User } from "@/types/user";
import axios, { AxiosResponse } from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Dispatch a custom event when a 401 error occurs
      window.dispatchEvent(new Event('UNAUTHORIZED'));
    }
    return Promise.reject(error);
  }
);

export function authenticateUser(code: string) {
  return api.post<User>("/request_access_token", {}, { params: { code } });
}

export function getClients() {
  return api.get("/clients");
}


interface GraphQLRequestParams<T = Record<string, any>> {
  query: string;
  variables?: T;
}

interface GraphQLResponse<T> {
  data: T;
  errors?: Array<{ message: string }>;
}
export async function runGraphql<T>({ query, variables }: GraphQLRequestParams): Promise<AxiosResponse<GraphQLResponse<T>>> {
  return api.post<GraphQLResponse<T>>("/graphql", { query, variables });
}

export function logout() {
  return api.get("/logout");
}

export default api;